import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex items-center h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium truncate mr-5" }, "CAT Online", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_8 = { class: "col-span-12 lg:col-span-12 xxl:col-span-12" }
const _hoisted_9 = { class: "intro-y grid grid-cols-12 gap-3 sm:gap-6" }
const _hoisted_10 = { class: "file box rounded-md px-5 pt-5 pb-5 lg:pt-7 sm:px-5 relative zoom-in" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "file__icon__file-name" }, " CAT Online ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  id: "modal-cat-online",
  class: "modal p-0"
}
const _hoisted_16 = { class: "modal__content modal__content--lg" }
const _hoisted_17 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-base mr-auto" }, "PERHATIAN !!!", -1)
const _hoisted_19 = { class: "px-3 md:px-5 py-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium mb-3" }, "Sebelum mulai mengerjakan Tryout ini pastikan terlebih dahulu :", -1)
const _hoisted_21 = {
  class: "pl-5",
  style: {"list-style":"decimal"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, "Pastikan Anda menggunakan Perangkat Komputer atau Laptop dengan jaringan Internet yang stabil.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, "Pastikan Anda sudah menguasai materi yang telah kami berikan.", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("li", null, "Siapkan alat bantu tulis disamping Anda untuk melakukan catatan-catatan kecil pada saat mulai mengerjakan soal.", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("li", null, "Yakinkan diri Anda untuk bisa berhasil menyelesaikan paket tryout ini dengan bisa menduduki peringkat teratas pada perengkingan.", -1)
const _hoisted_26 = { class: "text-base font-medium my-3" }
const _hoisted_27 = {
  class: "pl-5",
  style: {"list-style":"decimal"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "text-base font-medium my-3" }
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium text-center mt-3" }, "Pastikan Anda Sudah Berdo'a", -1)
const _hoisted_32 = { class: "px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!
  const _component_xIcon = _resolveComponent("xIcon")!
  const _component_TailSelect = _resolveComponent("TailSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", {
            href: "javascript:;",
            class: "ml-auto flex text-theme-1 dark:text-theme-10",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.getData();})
          }, [
            _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-3" }),
            _hoisted_6,
            _hoisted_7
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LoadingDiv, { id: "loadingCatOnline" }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catOnline.list, (faker, fakerKey) => {
          return (_openBlock(), _createElementBlock("div", {
            key: fakerKey,
            class: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: "w-3/5 file__icon file__icon--file mx-auto",
                onClick: ($event: any) => {_ctx.saveUrl(faker);}
              }, _hoisted_13, 8, _hoisted_11),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: ($event: any) => {_ctx.saveUrl(faker);},
                class: "block font-medium mt-4 text-center truncate"
              }, _toDisplayString(faker.title), 9, _hoisted_14)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$gpf.hideModal('#modal-cat-online');})
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("ol", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("li", null, "Waktu Anda sudah siap karena untuk mengerjakan tryout dibutuhkan waktu " + _toDisplayString(_ctx.catOnline.dataPG.durasi) + " menit.", 1),
            _hoisted_23,
            _hoisted_24,
            _hoisted_25
          ]),
          _createElementVNode("h5", _hoisted_26, "Nilai Ambang Batas : " + _toDisplayString(_ctx.catOnline.dataPG.title), 1),
          _createElementVNode("ol", _hoisted_27, [
            _createElementVNode("li", null, "Passing Grade = " + _toDisplayString(_ctx.catOnline.dataPG.nilaiPg), 1),
            _createElementVNode("li", null, "Jumlah Soal = " + _toDisplayString(_ctx.catOnline.dataPG.jmlSoal), 1),
            _createElementVNode("li", null, "Durasi " + _toDisplayString(_ctx.catOnline.dataPG.durasi) + " menit.", 1)
          ]),
          (_ctx.catOnline.dataPG.jurusan.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("h5", _hoisted_29, "Pilih Jurusan : " + _toDisplayString(_ctx.catOnline.dataPG.title), 1),
                _createVNode(_component_TailSelect, {
                  modelValue: _ctx.catOnline.dataPG.selectJurusan,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catOnline.dataPG.selectJurusan) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTS($event, 'selectJurusan'))),
                  options: {
                classNames: 'w-full',
              }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catOnline.dataPG.jurusan, (js, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: idx,
                        value: js.kode
                      }, _toDisplayString(js.title), 9, _hoisted_30))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_31
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            type: "button",
            class: "button w-20 bg-theme-1 text-white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoTryoutExam()))
          }, " Mulai ")
        ])
      ])
    ])
  ]))
}